import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'floating-action',
  name: '悬浮入口',
  icon: '浮',
  group: '营销组件',
  description: '在页面边缘展示稳定悬浮入口',
  defaultProps: {
    label: '快捷入口',
    icon: 'plus',
    linkTarget: '',
    position: 'BOTTOM_RIGHT'
  }
}
